export const trimString = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value.trim();
  return String(value).trim();
};

export const sanitizePhoneDigits = value => {
  return String(value ?? '').replace(/[^0-9]/g, '');
};

export const isValidEmail = email => {
  const e = trimString(email).toLowerCase();
  // Basic, robust email regex used consistently across app
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
};

export const isValidName = name => {
  const n = trimString(name);
  // Letters with common separators; no digits allowed, must contain at least one letter
  return /^[A-Za-z][A-Za-z\s'\.-]*$/.test(n);
};

export const isValidPhoneNumber = (digitsOnlyPhone, minLength = 5, maxLength = 15) => {
  const d = sanitizePhoneDigits(digitsOnlyPhone);
  return d.length >= minLength && d.length <= maxLength;
};

export const validators = {
  trimString,
  sanitizePhoneDigits,
  isValidEmail,
  isValidName,
  isValidPhoneNumber,
};
